// import { AppmetricaPushPlugin as IAppmetricaPushPlugin } from './definitions';
// import { Plugins } from '@capacitor/core';
// const AppmetricaPushPlugin = Plugins.Appmetrica as IAppmetricaPushPlugin;
export class AppmetricaPush {
}
//# sourceMappingURL=plugin.js.map